export default __webpack_public_path__ + "img/dan.bdc507fc.jpg";